import React from 'react';
import { WebinarLandingPage } from './pages/WebinarLandingPage';
export function App() {
  return <WebinarLandingPage data-id="element-0" />;
}